angular.module('checkout').directive('cartUiTotals', [function () {
    return {
        scope: {
            orderTotals: '=orderTotals',
        },
        template: `
<tr ng-show="orderTotals" class="bvPv">
    <td data-textEdit="bvTotal">
        {{'BV Total' | translate}}
    </td>
    <td class="money bvSubtotalVal">
        {{orderTotals.formatted.bvSubTotal}}
    </td>
</tr>
<tr ng-show="orderTotals" class="bvPv">
    <td data-textEdit="pvTotal">
        {{'PV Total' | translate}}
    </td>
    <td class="money pvSubtotalVal">
        {{orderTotals.formatted.pvSubTotal}}
    </td>
</tr>
<tr ng-show="orderTotals" class="subtotal">
    <td data-textEdit="totalsSubTotal">
        {{'Subtotal' | translate}}
    </td>
    <td class="money subtotalVal">
        {{orderTotals.formatted.subTotal}}
    </td>
</tr>

<tr ng-show="orderTotals && orderTotals.discount != 0 && orderTotals.totalCalculated" class="discounts finalTotal">
    <td data-textEdit="discounts">
        {{'Discounts' | translate}}
    </td>
    <td class="money totalsDiscountTotal">
        {{orderTotals.formatted.discount}}
    </td>
</tr>
<tr ng-show="orderTotals && orderTotals.couponDiscount != 0 && orderTotals.totalCalculated" class="couponDiscount finalTotal">
    <td data-textEdit="couponDiscount">
        {{'Coupon Discount' | translate}}
    </td>
    <td class="money totalsCouponTotal">
        {{orderTotals.formatted.couponDiscount}}
    </td>
</tr>
<tr ng-show="orderTotals && orderTotals.totalCalculated" class="tax finalTotal">
    <td data-textEdit="taxConfirmPage">
        {{'Tax' | translate}}
    </td>
    <td class="money totalsTaxTotal">
        {{orderTotals.formatted.tax}}
    </td>
</tr>
<tr ng-show="orderTotals && orderTotals.totalCalculated" class="shipping finalTotal">
    <td data-textEdit="shipConfirmPage">
        {{'Shipping' | translate}}
    </td>
    <td class="money totalsShipTotal">
        {{orderTotals.formatted.shipping}}
    </td>
</tr>
<tr ng-show="orderTotals && orderTotals.totalCalculated" class="total finalTotal">
    <td data-textEdit="totalConfirmPage">
        {{'Total' | translate}}
    </td>
    <td class="money totalsFinalTotal">
        {{orderTotals.formatted.total}}
    </td>
</tr>
`,
    };
},
]);
